document.addEventListener('click', event => {
  const triggerElement = event.target.closest('[data-modal-trigger]');
  if (triggerElement) {
    const modalContentId = triggerElement.getAttribute('data-modal-content-id');
    const modalContent = modalContentId ? document.getElementById(modalContentId) : null;

    if (modalContent instanceof HTMLTemplateElement && typeof window.showModal === 'function') {
      event.preventDefault();
      event.stopPropagation();
      window.showModal(modalContent.innerHTML, {
        ariaLabel: triggerElement.getAttribute('data-modal-label') || undefined,
        closeLabel: triggerElement.getAttribute('data-modal-close-label') || undefined,
        source: 'manual'
      });
      return;
    }

    const modalId = triggerElement.getAttribute('data-modal-id');
    if (modalId) {
      event.preventDefault();
      event.stopPropagation();
      if (modalId === 'pacmangametest') {
        window.dispatchEvent(new CustomEvent('pacman:open', {
          detail: { modalId }
        }));
        return;
      }
      window.activeModalID = modalId;
      if (typeof window.showModal === 'function') {
        window.showModal(undefined, {
          modalId,
          source: 'manual'
        });
      }
    }
  }
});
